import { useState } from 'react'
import { ICriteria } from '../../../protection.types'
import Button from 'shared/Buttons/Button/Button'
import TextField from 'shared/Forms/TextField'
import TextInput from 'shared/Inputs/TextInput'
import CriteriaTemplate from '../CriteriaTemplate'
import useHttpLoader from 'shared/hooks/useHttpLoader'
import eventBus from 'services/eventBus'
import { useNavigate } from 'react-router-dom'
import protectionTemplateApi from '../../../protection.api'

const ProtectionCriteria = () => {
  const { wait } = useHttpLoader()
  const navigate = useNavigate()

  const [templateName, setTemplateName] = useState('')
  const [templateDescription, setTemplateDescription] = useState('')
  const [templateCreated, setTemplateCreated] = useState(false)
  const [templateId, setTemplateId] = useState<string>('')

  const [criteriaDraft, setCriteriaDraft] = useState<ICriteria[]>([])

  const handleChange = (criteriaId: string) => (value: any, name: string) => {
    setCriteriaDraft((prev) =>
      prev.map((criteria) => (criteria.id === criteriaId ? { ...criteria, [name]: value } : criteria))
    )
  }
  const handleDeleteCriteria = (criteria: ICriteria) => {
    const isExisting = criteria.ratingTemplateId

    console.log(isExisting)

    if (isExisting) {
      wait(protectionTemplateApi.deleteCriteriaFromTemplate(criteria.id), (resp) => {
        if (resp.status === 'success') {
          eventBus.pub('ntf.message', {
            type: 'info',
            message: 'Критерий успешно удален',
          })

          setCriteriaDraft((prev) => prev.filter((c) => c.id !== criteria.id))
        }
      })
    } else {
      setCriteriaDraft((prev) => prev.filter((c) => c.id !== criteria.id))
    }
  }

  const handleAddCriteria = () => {
    const newCriteria: ICriteria = {
      id: crypto.randomUUID(),
      name: '',
      description: '',
      minValue: 0,
      maxValue: 10,
    }
    setCriteriaDraft((prev) => [...prev, newCriteria])
  }

  const handleCreateAllCriteria = () => {
    criteriaDraft.forEach((criteria) => {
      const criteriaData = {
        name: criteria.name,
        description: criteria.description,
        minValue: criteria.minValue,
        maxValue: criteria.maxValue,
        ratingTemplateId: templateId,
      }

      wait(protectionTemplateApi.createCriteriaFromTemplate(templateId, criteriaData), (resp) => {
        if (resp.status === 'success' && resp.body) {
          setCriteriaDraft((prev) =>
            prev.map((c) =>
              c.id === criteria.id
                ? {
                    ...c,
                    ...resp.body,
                  }
                : c
            )
          )
        }
      })
    })

    eventBus.pub('ntf.message', {
      type: 'info',
      message: 'Критерии успешно добавлены',
    })
  }

  const handleCreateTemplate = () => {
    wait(
      protectionTemplateApi.createRatingTempalte({
        name: templateName,
        description: templateDescription,
      }),
      (resp) => {
        if (resp.status === 'success') {
          eventBus.pub('ntf.message', {
            type: 'info',
            message: 'Шаблон успешно создан',
          })

          if (resp.status === 'success') {
            setTemplateId(resp.body?.template?.id)
          }

          setTemplateCreated(true)
        }
      }
    )
  }

  const handleDeleteTemplate = () => {
    if (!templateId) return

    wait(protectionTemplateApi.deleteTemplate(templateId), (resp) => {
      if (resp.status === 'success') {
        eventBus.pub('ntf.message', {
          type: 'info',
          message: 'Шаблон успешно удален',
        })

        navigate('/admin/protection-templates')
      }
    })
  }

  return (
    <>
      {!templateCreated ? (
        <div className='flex-lines'>
          <TextField header='Название шаблона'>
            <TextInput name='templateName' onChange={setTemplateName} value={templateName} />
          </TextField>

          <TextField header='Описание шаблона'>
            <TextInput name='templateDesciprition' onChange={setTemplateDescription} value={templateDescription} />
          </TextField>

          <Button theme='primary' onClick={handleCreateTemplate}>
            Создать шаблон
          </Button>
        </div>
      ) : (
        <div>
          <div
            style={{
              marginTop: '16px',
              display: 'flex',
              justifyContent: 'end',
              gap: '12px',
            }}
          >
            <Button theme='primary' onClick={handleAddCriteria} size='s' fullWidth={false}>
              Добавить
            </Button>

            <Button theme='primary' onClick={handleCreateAllCriteria} size='s' fullWidth={false}>
              Сохранить все
            </Button>
            <Button theme='danger' onClick={handleDeleteTemplate} size='s' fullWidth={false}>
              Удалить шаблон
            </Button>
          </div>
          <div className='grid-form-2' style={{ marginTop: '16px' }}>
            {criteriaDraft.map((criteria) => (
              <CriteriaTemplate key={criteria.id} criteria={criteria} onChange={handleChange(criteria.id)}>
                <div className='form-footer'>
                  <div className='inline-flex-gap'>
                    <Button theme='danger' onClick={() => handleDeleteCriteria(criteria)} fullWidth={false}>
                      Удалить
                    </Button>
                  </div>
                </div>
              </CriteriaTemplate>
            ))}
          </div>
        </div>
      )}
    </>
  )
}

export default ProtectionCriteria
